var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2222_18663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3684 18.9648H19.8531C13.2021 18.9648 7.81055 24.3566 7.81055 31.0074C7.81055 32.006 8.38469 32.9113 9.27952 33.3546C12.6958 35.0458 16.5409 36.0004 20.6112 36.0004C24.6816 36.0004 28.5267 35.0459 31.943 33.3546C32.8378 32.9117 33.4119 32.006 33.4119 31.0074C33.4119 24.3564 28.0201 18.9648 21.3694 18.9648H21.3684Z",
    fill: "#6B6C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25433 31.0077C6.25433 26.8351 8.14526 23.0973 11.1132 20.6006C11.0676 20.5999 11.0235 20.5938 10.9776 20.5938H9.80658C4.66681 20.5938 0.5 24.7603 0.5 29.9003C0.5 30.6719 0.943624 31.3718 1.63493 31.7143C3.32557 32.5513 5.15357 33.1514 7.07477 33.4772C6.5545 32.7751 6.25369 31.9208 6.25369 31.0081L6.25433 31.0077Z",
    fill: "#6B6C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0102 10.4001C27.0102 13.935 24.1449 16.8002 20.6101 16.8002C17.0752 16.8002 14.21 13.935 14.21 10.4001C14.21 6.86528 17.0752 4 20.6101 4C24.1449 4 27.0102 6.86528 27.0102 10.4001Z",
    fill: "#6B6C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6549 10.4012C12.6549 10.1314 12.669 9.86462 12.6954 9.60178C12.0074 9.23878 11.2246 9.03125 10.3923 9.03125C7.6608 9.03125 5.44629 11.2458 5.44629 13.9769C5.44629 16.7085 7.6608 18.9226 10.3923 18.9226C12.4203 18.9226 14.1612 17.701 14.9244 15.9543C13.5226 14.5193 12.6549 12.5608 12.6549 10.4013L12.6549 10.4012Z",
    fill: "#6B6C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.827 9.03136C29.9951 9.03136 29.212 9.23925 28.5239 9.60189C28.5503 9.86473 28.5644 10.1316 28.5644 10.4013C28.5644 12.5608 27.6967 14.5193 26.2949 15.9543C27.0582 17.701 28.799 18.9226 30.827 18.9226C33.5585 18.9226 35.7726 16.7085 35.7726 13.9769C35.7726 11.2454 33.5585 9.03125 30.827 9.03125L30.827 9.03136Z",
    fill: "#6B6C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4131 20.5942H30.242C30.1965 20.5942 30.152 20.6003 30.1064 20.6011C33.0744 23.0976 34.9653 26.8352 34.9653 31.0081C34.9653 31.9207 34.6645 32.7751 34.1442 33.4772C36.0655 33.1514 37.8935 32.5513 39.5844 31.7143C40.2761 31.3719 40.7194 30.6723 40.7194 29.9003C40.7194 24.7606 36.5528 20.5938 31.4128 20.5938L31.4131 20.5942Z",
    fill: "#6B6C7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2222_18663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.4f1e24a52ea1ab6f17bf4f9ff802400c.svg";
export { ForwardRef as ReactComponent };